import React from 'react';

function Todo() {
  return (
    <div>
      <svg
        width='80'
        height='80'
        viewBox='0 0 80 80'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g filter='url(#filter0_i_115_339)'>
          <rect width='80' height='80' rx='40' fill='currentColor' />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M36.5 19.8332C33.2923 19.8332 30.3855 19.8332 28.625 19.8332C27.1751 19.8332 26 21.0643 26 22.5832C26 29.3015 26 52.5317 26 59.2499C26 60.7688 27.1751 61.9999 28.625 61.9999C33.3981 61.9999 46.6019 61.9999 51.375 61.9999C52.8249 61.9999 54 60.7688 54 59.2499C54 52.5317 54 29.3015 54 22.5832C54 21.0643 52.8249 19.8332 51.375 19.8332C49.6145 19.8332 46.7078 19.8332 43.5 19.8332C43.017 19.8332 42.625 20.2439 42.625 20.7499C42.625 21.2559 43.017 21.6665 43.5 21.6665C46.7078 21.6665 49.6145 21.6665 51.375 21.6665C51.858 21.6665 52.25 22.0772 52.25 22.5832C52.25 29.3015 52.25 52.5317 52.25 59.2499C52.25 59.7559 51.858 60.1666 51.375 60.1666C46.6019 60.1666 33.3981 60.1666 28.625 60.1666C28.142 60.1666 27.75 59.7559 27.75 59.2499C27.75 52.5317 27.75 29.3015 27.75 22.5832C27.75 22.0772 28.142 21.6665 28.625 21.6665C30.3855 21.6665 33.2923 21.6665 36.5 21.6665C36.983 21.6665 37.375 21.2559 37.375 20.7499C37.375 20.2439 36.983 19.8332 36.5 19.8332Z'
            fill='#FEFEFE'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M44.3753 18.9167C44.3753 18.4107 43.9833 18 43.5003 18H36.5003C36.0173 18 35.6253 18.4107 35.6253 18.9167V20.75C35.6253 22.2689 36.8004 23.5 38.2503 23.5C39.3195 23.5 40.681 23.5 41.7503 23.5C43.2002 23.5 44.3753 22.2689 44.3753 20.75C44.3753 19.8333 44.3753 18.9167 44.3753 18.9167ZM42.6253 19.8333H37.3753V20.75C37.3753 21.256 37.7673 21.6667 38.2503 21.6667C39.3195 21.6667 40.681 21.6667 41.7503 21.6667C42.2333 21.6667 42.6253 21.256 42.6253 20.75V19.8333ZM42.6253 31.75H48.7503C49.2333 31.75 49.6253 31.3394 49.6253 30.8334C49.6253 30.3274 49.2333 29.9167 48.7503 29.9167H42.6253C42.1423 29.9167 41.7503 30.3274 41.7503 30.8334C41.7503 31.3394 42.1423 31.75 42.6253 31.75ZM42.6253 39.0834H48.7503C49.2333 39.0834 49.6253 38.6727 49.6253 38.1667C49.6253 37.6607 49.2333 37.25 48.7503 37.25H42.6253C42.1423 37.25 41.7503 37.6607 41.7503 38.1667C41.7503 38.6727 42.1423 39.0834 42.6253 39.0834ZM42.6253 46.4167H48.7503C49.2333 46.4167 49.6253 46.006 49.6253 45.5C49.6253 44.994 49.2333 44.5834 48.7503 44.5834H42.6253C42.1423 44.5834 41.7503 44.994 41.7503 45.5C41.7503 46.006 42.1423 46.4167 42.6253 46.4167ZM42.6253 53.7501H48.7503C49.2333 53.7501 49.6253 53.3394 49.6253 52.8334C49.6253 52.3274 49.2333 51.9167 48.7503 51.9167H42.6253C42.1423 51.9167 41.7503 52.3274 41.7503 52.8334C41.7503 53.3394 42.1423 53.7501 42.6253 53.7501ZM33.8753 31.3705L37.6317 27.4353C37.9729 27.0778 38.5277 27.0778 38.8689 27.4353C39.2102 27.7928 39.2102 28.3739 38.8689 28.7314L34.4939 33.3148C34.1527 33.6732 33.5979 33.6732 33.2567 33.3148L30.6317 30.5648C30.2904 30.2073 30.2904 29.6261 30.6317 29.2686C30.9729 28.9111 31.5277 28.9111 31.8689 29.2686L33.8753 31.3705ZM33.8753 38.7039L37.6317 34.7686C37.9729 34.4111 38.5277 34.4111 38.8689 34.7686C39.2102 35.1261 39.2102 35.7073 38.8689 36.0648L34.4939 40.6481C34.1527 41.0065 33.5979 41.0065 33.2567 40.6481L30.6317 37.8981C30.2904 37.5406 30.2904 36.9594 30.6317 36.6019C30.9729 36.2444 31.5277 36.2444 31.8689 36.6019L33.8753 38.7039ZM33.8753 46.0372L37.6317 42.102C37.9729 41.7445 38.5277 41.7445 38.8689 42.102C39.2102 42.4595 39.2102 43.0406 38.8689 43.3981L34.4939 47.9815C34.1527 48.3399 33.5979 48.3399 33.2567 47.9815L30.6317 45.2315C30.2904 44.874 30.2904 44.2928 30.6317 43.9353C30.9729 43.5778 31.5277 43.5778 31.8689 43.9353L33.8753 46.0372ZM33.8753 53.3706L37.6317 49.4353C37.9729 49.0778 38.5277 49.0778 38.8689 49.4353C39.2102 49.7928 39.2102 50.374 38.8689 50.7315L34.4939 55.3148C34.1527 55.6732 33.5979 55.6732 33.2567 55.3148L30.6317 52.5648C30.2904 52.2073 30.2904 51.6261 30.6317 51.2686C30.9729 50.9111 31.5277 50.9111 31.8689 51.2686L33.8753 53.3706Z'
            fill='#FEFEFE'
          />
        </g>
        <defs>
          <filter
            id='filter0_i_115_339'
            x='-4.42632'
            y='-0.737721'
            width='84.4263'
            height='80.7377'
            filterUnits='userSpaceOnUse'
            color-interpolation-filters='sRGB'
          >
            <feFlood flood-opacity='0' result='BackgroundImageFix' />
            <feBlend
              mode='normal'
              in='SourceGraphic'
              in2='BackgroundImageFix'
              result='shape'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dx='-4.42632' dy='-0.737721' />
            <feGaussianBlur stdDeviation='2.21316' />
            <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0.564706 0 0 0 0 0.564706 0 0 0 0 0.866667 0 0 0 1 0'
            />
            <feBlend
              mode='normal'
              in2='shape'
              result='effect1_innerShadow_115_339'
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
}

export default Todo;
